export default "__VITE_ASSET__5c072468__"